var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6794_6136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 9.66634C10.3013 9.66634 12.1668 7.80086 12.1668 5.49967C12.1668 3.19849 10.3013 1.33301 8.00016 1.33301C5.69898 1.33301 3.8335 3.19849 3.8335 5.49967C3.8335 7.80086 5.69898 9.66634 8.00016 9.66634ZM8.00016 9.66634C4.31826 9.66634 1.3335 11.9049 1.3335 14.6663M8.00016 9.66634C11.6821 9.66634 14.6668 11.9049 14.6668 14.6663",
    stroke: "#000536",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6794_6136"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f15d98a8f250b063bcded9db461a459c.svg";
export { ForwardRef as ReactComponent };